// extracted by mini-css-extract-plugin
module.exports = {"container":"UserNotActive_container__3BhBz"};